import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  // Divider,
  Tooltip,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";

export default function OpsSalesPage() {
  const pageTitle = "Sales";
  usePageTitle(pageTitle);
  const { filterType, filterRef } = useParams();
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [sales, setSales] = useState([]);

  let salesTableColumns = [
    { Header: "Sales Rule", accessor: "rule", align: "left" },
    { Header: "Entity Type", accessor: "relationship", align: "left" },
    { Header: "Entity", accessor: "entity", align: "left" },
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Amount", accessor: "amount", align: "left" },
    { Header: "Status", accessor: "status", align: "left" },
    { Header: "Date", accessor: "date", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildSalesRows = (data, currency) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        rule: row.rule,
        relationship: row.entity.type,
        entity: row.entity.title,
        agent: row.agent,
        amount: `${currency}${(row.amount / 100).toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        status: row.status,
        date: row.created,
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="View Sale">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  navigate(`/ops/sales/${row.reference}`);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>east</Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      let queryParams = {};
      if (filterType && filterRef) {
        queryParams[filterType] = filterRef;
      }
      console.log(queryParams);
      setShowLoading(true);
      await axios
        .get(`/portal/ops/sales.json`, { params: queryParams })
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const pArows = buildSalesRows(result.data.data.sales, result.data.currency);
            setSales(pArows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} pb={3} mb={5}>
        <MDBox mt={1} display="flex" justifyContent="space-between">
          <Button
            color="dark"
            startIcon={<Icon>west</Icon>}
            onClick={() => {
              navigate(`/ops`);
            }}
          >
            Back
          </Button>
          <MDBox>
            <Button
              color="dark"
              startIcon={<Icon>bar_chart</Icon>}
              onClick={() => {
                let url = `/ops/sales/insights`;
                if (filterType && filterRef) {
                  url += `/${filterType}/${filterRef}`;
                }
                navigate(url);
              }}
            >
              Insights
            </Button>
          </MDBox>
        </MDBox>
        {pageLoaded && (
          <MDBox>
            <MDBox mt={2}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Sales Orders
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  {sales.length >= 0 ? (
                    <MDBox mt={0}>
                      <DataTable
                        table={{ columns: salesTableColumns, rows: sales }}
                        isSorted
                        canSearch
                        entriesPerPage
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  ) : (
                    <MDBox p={2}>
                      <MDTypography variant="body2">No sales recorded.</MDTypography>
                    </MDBox>
                  )}
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
